import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getCancelDialogStyles = (): SerializedStyles =>
    css({
        minWidth: 680,
    });

export const getCancelDialogHeaderStyles = (theme: Theme): SerializedStyles =>
    css({
        padding: theme.spacing(2),
        alignItems: 'center',
    });

export const getCancelDialogHeaderTitleStyles = (): SerializedStyles =>
    css({
        marginBottom: 0,
    });

export const getImageStyles = (theme: Theme): SerializedStyles =>
    css({
        height: 95,
        marginBottom: theme.spacing(3),
        marginRight: theme.spacing(2),
    });

export const getTitleStyles = (theme: Theme): SerializedStyles =>
    css({
        marginBottom: theme.spacing(2),
    });

export const getMessageStyles = (theme: Theme): SerializedStyles =>
    css({
        margin: theme.spacing(),
        textAlign: 'start',
    });

export const getCancellationSuccessDialogStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        flexDirection: 'row',
        margin: `0px ${theme.spacing(4)}px`,
    });

export const getCancellationActionsStyles = (theme: Theme): SerializedStyles =>
    css({
        justifyContent: 'flex-end',
        marginRight: theme.spacing(4),
    });

export const getCancellationSurveyFormStyles = (theme: Theme): SerializedStyles =>
    css({
        textAlign: 'left',
        margin: `0px ${theme.spacing(4)}px`,
    });

export const getCancellationSurveyRadioStyles = (theme: Theme): SerializedStyles =>
    css({
        marginBottom: theme.spacing(2),

        span: {
            fontWeight: 'unset',
        },
    });
